/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PatientLabOrderStatus } from "./PatientLabOrderStatus";

export interface PatientLabOrderItem {
  service_request_id: string;
  test_name: string;
  test_code: string;
  cursor: string;
  authored_at?: string | null;
  ordered_at?: string | null;
  patient_status: PatientLabOrderStatus;
}
